import { Link } from '@remix-run/react'
import { Container, Row, Col } from 'reactstrap'

export default function Footer() {
  const navigationLinks = [
    { title: 'Loja CdT', url: 'https://loja.clubedotennis.com.br' },
    { title: 'Termos de uso', url: '/clube/termos-de-uso' },
    { title: 'Política de Privacidade', url: '/clube/politica-de-privacidade' },
  ]

  return (
    <footer className="footer-section">
      <div className="footer-section-line" />
      <Container>
        <Row className="align-items-center">
          <Col lg="9" className="footer-left">
            <Link to="/">
              <div className="footer-logo">
                <img
                  src="/images/logo-white.svg"
                  alt="logo clube do tennis"
                  className="footer-logo-img"
                />
              </div>
            </Link>
            <div className="footer-links">
              {navigationLinks.map((link, index) => (
                <Link key={index} to={link.url} className="footer-link">
                  {link.title}
                </Link>
              ))}
            </div>
          </Col>
          <Col lg="3" className="footer-right">
            <div className="footer-social">
              <a
                href="https://instagram.com/clubedotennisbr"
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="2"
                    y="2"
                    width="20"
                    height="20"
                    rx="5"
                    ry="5"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <path
                    d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <line
                    x1="17.5"
                    y1="6.5"
                    x2="17.51"
                    y2="6.5"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                </svg>
              </a>
              <a
                href="https://linkedin.com/company/clube-do-tennis/"
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <rect
                    x="2"
                    y="9"
                    width="4"
                    height="12"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <circle
                    cx="4"
                    cy="4"
                    r="2"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@clubedotennis"
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <polygon
                    points="9.75,15.02 15.5,11.75 9.75,8.48"
                    fill="currentColor"
                  />
                </svg>
              </a>
              <a
                href="https://www.tiktok.com/@clubedotennis"
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                </svg>
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
